export function Kpi({ label, valeur, detail }: { label: string; valeur: string; detail?: string }) {
  return (
    <div className="carte-admin p-4">
      <p className="kicker text-second-admin">{label}</p>
      <p className="mt-2 font-titre text-admin-kpi leading-none text-encre-admin tabular-nums">
        {valeur}
      </p>
      {detail && <p className="mt-1.5 text-xs text-second-admin">{detail}</p>}
    </div>
  )
}
